export const EVENT_SERIES_LIMIT = 20;
export const EVENT_SERIES_PAGE_SIZE = 20;
export const EVENT_LISTING_PAGE_SIZE = 20;
export const ORG_SPACES_PAGE_SIZE = 20;
